import { useRef } from "react";
import { Camera, X } from "lucide-react";

// Carga de foto local (sin backend): convierte el archivo a data URL y lo
// devuelve por onChange. Al conectar una base real, reemplazar por una subida
// a object storage y guardar la URL devuelta.
export function PhotoInput({ label, value, onChange, testId }) {
  const ref = useRef(null);
  const handle = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => onChange(reader.result);
    reader.readAsDataURL(file);
  };
  return (
    <div className="flex flex-col items-center gap-1">
      <button
        type="button"
        onClick={() => ref.current?.click()}
        data-testid={testId}
        className="flex h-20 w-24 items-center justify-center rounded-md border border-dashed border-slate-300 bg-slate-50 overflow-hidden hover:border-slate-400 transition-colors"
      >
        {value ? (
          <img src={value} alt={label} className="h-full w-full object-cover" />
        ) : (
          <span className="flex flex-col items-center text-[10px] text-slate-400">
            <Camera className="h-4 w-4 mb-1" />
            Subir
          </span>
        )}
      </button>
      <div className="flex items-center gap-1">
        <span className="text-[10px] text-slate-400">{label}</span>
        {value && (
          <button type="button" onClick={() => onChange(null)} className="text-slate-300 hover:text-red-500">
            <X className="h-3 w-3" />
          </button>
        )}
      </div>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={handle} />
    </div>
  );
}
